import { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
//Props Validations
import PropTypes from "prop-types";

// mui component
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// mui icon
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

//import component
import Header from "../components/common/Header";
import FiltersHeaderLabel from "../components/common/FiltersHeaderLabel";
import FullScreenConatiner from "../components/layouts/FullScreenConatiner";

import DataSeeding from "../components/dataControlPanel/dataManagement/DataSeeding";
import ClaimsMapping from "../components/dataControlPanel/claimsMapping/ClaimsMapping";
import StudyMethodTable from "../components/studyMethodManagement/StudyMethodTable";
import CentralizedDataMapping from "../components/dataControlPanel/centralizedDataMapping/CentralizedDataMapping";
import RespondentSettings from "../components/dataControlPanel/respondentSettings/Settings";

// redux
import { useSelector } from "react-redux";

function CustomTabPanel(props) {
    const { children, value, index, height = 200, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <FullScreenConatiner
                    style={{
                        padding: "20px",
                    }}
                    subHeight={height}
                >
                    {children}
                </FullScreenConatiner>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    height: PropTypes.number,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

function DataControlPanel({ headerTitle }) {
    const [value, setValue] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();

    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);

    // Check if it's Hair Care
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();

    // Check if it's Unilever Fragrance House
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();

    const tabPaths = {
        0: "data-management",
        1: "claims-mapping",
        2: "centralized-data-mapping",
        3: "study-method-management",
        4: "respondent-settings",
    };

    useEffect(() => {
        const path = location.pathname;

        if (isHairCare || isUnileverFragranceHouse) {
            // For Hair Care, adjust the tab
            if (path.includes("claims-mapping")) {
                navigate("/data-control-panel/data-management");
                setValue(0);
            } else if (path.includes("centralized-data-mapping")) {
                setValue(1); // This is now index 1 for Hair Care
            } else if (path.includes("study-method-management")) {
                setValue(2); // This is now index 2 for Hair Care
            } else if (path.includes("respondent-settings")) {
                setValue(3); // This is now index 3 for Hair Care
            } else {
                setValue(0); // Default to data-management
            }
        } else {
            if (path.includes("claims-mapping")) {
                setValue(1);
            } else if (path.includes("centralized-data-mapping")) {
                setValue(2);
            } else if (path.includes("study-method-management")) {
                setValue(3);
            } else if (path.includes("respondent-settings")) {
                setValue(4);
            } else {
                setValue(0); // Default to data-management
            }
        }
    }, [location.pathname, isHairCare,isUnileverFragranceHouse,  navigate]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        const pathKey = (isHairCare || isUnileverFragranceHouse) ? (newValue === 1 ? "centralized-data-mapping" : newValue === 2 ? "study-method-management" : newValue === 3 ? "respondent-settings" : "data-management") : tabPaths[newValue];

        navigate(`/data-control-panel/${pathKey}`);
    };

    return (
        <>
            <Header
                title={headerTitle}
                isStudySelected={false}
            />
            <div
                className="ms-4 me-4 mb-0 mt-3 background-color-white box-shadow--2 d-flex"
                style={{
                    borderRadius: "5px",
                }}
            >
                <FiltersHeaderLabel />
            </div>
            <div
                className="ms-4 me-4 mb-0 mt-3 background-color-white box-shadow--2 d-flex"
                style={{
                    borderRadius: "5px",
                }}
            >
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    sx={{
                        maxHeight: "35px",
                        minHeight: "8px",
                        display: "flex",
                        alignItems: "center",
                        "& .MuiTabs-flexContainer": {
                            height: "35px",
                        },
                        "& .MuiTab-root": {
                            minHeight: "30px",
                            padding: "0px 12px",
                            fontSize: "12px",
                            textTransform: "none",
                        },
                    }}
                >
                    <Tab
                        className="cp-tab-labels"
                        label="Data Management"
                        {...a11yProps(0)}
                    />
                    {/* Hide Claims Mapping tab for Hair Care */}
                    {!(isHairCare || isUnileverFragranceHouse) && (
                        <Tab
                            className="cp-tab-labels"
                            label="Claims Mapping"
                            {...a11yProps(1)}
                        />
                    )}
                    <Tab
                        className="cp-tab-labels"
                        label="Centralized Data Mapping"
                        {...a11yProps((isHairCare || isUnileverFragranceHouse) ? 1 : 2)}
                    />
                    <Tab
                        className="cp-tab-labels"
                        label="Study Method Management"
                        {...a11yProps((isHairCare || isUnileverFragranceHouse) ? 2 : 3)}
                    />
                    <Tab
                        className="cp-tab-labels"
                        label="Respondent Settings"
                        {...a11yProps((isHairCare || isUnileverFragranceHouse) ? 3 : 4)}
                    />
                </Tabs>
            </div>
            <div
                className=""
                style={{
                    width: 150,
                    display: "flex",
                    alignItems: "center",
                    position: "absolute",
                    zIndex: 1,
                }}
            >
                <Link to="/studies">
                    <div
                        className="p-2 liner-light-blue-background color-white"
                        style={{
                            borderRadius: "50%",
                            position: "relative",
                            top: 0,
                            left: 0,
                            cursor: "pointer",
                        }}
                    >
                        <span>
                            <ArrowBackIcon className="color-white" />
                        </span>
                    </div>
                </Link>
            </div>

            <CustomTabPanel
                value={value}
                index={0}
            >
                <DataSeeding />
            </CustomTabPanel>

            {!(isHairCare || isUnileverFragranceHouse) && (
                <CustomTabPanel
                    value={value}
                    index={1}
                >
                    <ClaimsMapping />
                </CustomTabPanel>
            )}

            {/* Adjust panel indices for Hair Care */}
            <CustomTabPanel
                value={value}
                index={(isHairCare || isUnileverFragranceHouse) ? 1 : 2}
            >
                <CentralizedDataMapping />
            </CustomTabPanel>

            <CustomTabPanel
                value={value}
                index={(isHairCare || isUnileverFragranceHouse) ? 2 : 3}
            >
                <StudyMethodTable />
            </CustomTabPanel>

            <CustomTabPanel
                value={value}
                index={(isHairCare || isUnileverFragranceHouse) ? 3 : 4}
                height={105}
            >
                <RespondentSettings />
            </CustomTabPanel>
        </>
    );
}

// Typechecking props for the ClaimsMapping
DataControlPanel.propTypes = {
    headerTitle: PropTypes.string,
};

export default DataControlPanel;
